import { createEditorConfigMixin } from './editorConfig';

export default createEditorConfigMixin('InlineEditor');
